//local url

// export const url = "http://localhost:4022";
// export const url = "http://192.168.0.29:4022";

/////live url
export const url = "https://appadmin.nikkypore.com/api";
